<template>
  <div class="ShareView">

    <slider :items="items" v-if="animal.id" />

  </div>
</template>

<script>
import Slider from 'components/Slider/Slider'

export default {
  name: 'Share',

  components: {
    Slider
  },

  computed: {
    animal () { return this.$store.state.animal },

    items () {
      return [
        {
          template: 'share',
          image: this.animal.image,
          content: {
            title: `Sign up for the PetSpace newsletter to be notified about new adoptables, events, and more!`,
            footer: ''
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Share.vue?0e947894